"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TEXT_CONTENT = exports.PANEL_CONFIG = exports.IMAGE_PATHS = exports.DNS_TABLE = exports.BUTTONS = void 0;

var _globals = _interopRequireDefault(require("@insided/shared/utils/globals"));

/**
 * Constants and configuration for community settings
 */

/**
 * Base path for images
 */
var getImagePath = function getImagePath(path) {
  return "".concat((0, _globals.default)('basePath'), "images/").concat(path);
};
/**
 * Image paths for panels
 */


var IMAGE_PATHS = {
  CC_LOGO: function CC_LOGO() {
    return getImagePath('CC-logo-no-text.png');
  },
  AWS_LOGO: function AWS_LOGO() {
    return getImagePath('destination-url/aws.png');
  },
  DNS_ICON: function DNS_ICON() {
    return getImagePath('destination-url/dns.png');
  }
};
/**
 * Panel configuration
 */

exports.IMAGE_PATHS = IMAGE_PATHS;
var PANEL_CONFIG = {
  ENTER_URL: {
    title: 'Enter Custom URL',
    customClass: 'enter-custom-url-panel'
  },
  DNS_CONFIG: {
    title: 'DNS Configuration',
    customClass: 'dns-configuration-panel'
  },
  CONNECTION_CHECK: {
    title: 'Connection Check',
    customClass: 'connection-check-panel'
  }
};
/**
 * DNS table configuration
 */

exports.PANEL_CONFIG = PANEL_CONFIG;
var DNS_TABLE = {
  HEADERS: ['TYPE', 'NAME (SUBDOMAIN)', 'VALUE/POINTS TO'],
  PLACEHOLDER: {
    Type: 'NOT FOUND',
    Name: 'NOT FOUND',
    Value: 'NOT FOUND'
  }
};
/**
 * Text content
 */

exports.DNS_TABLE = DNS_TABLE;
var TEXT_CONTENT = {
  DNS_INSTRUCTIONS: 'DNS Instructions that needs to be copied at your DNS service provider.',
  CNAME_SETUP_INSTRUCTION: '⚠️ To complete setup, please point your domain to our internal domain using a CNAME record.',
  URL_META: "Change the destination URL for the community below. Enter the URL without including 'http://' or 'https://'.",
  URL_PLACEHOLDER: 'Enter URL',
  CONNECTION_SUCCESS: 'Your custom domain has been successfully linked. The destination URL is now active and ready to use.',
  CONNECTION_FAILED: 'We couldn’t verify the connection. Please review your DNS configuration and try again.',
  CONNECTION_PROGRESS: 'Verifying DNS record propagation. This may take up to 20 minutes depending on your DNS provider.',
  CONNECTION_INITIAL: "After you've added the DNS records to your DNS provider, you can verify the connection to your Customer Community. Connection setup may take up to 20–30 minutes to reflect."
};
/**
 * Button configurations
 */

exports.TEXT_CONTENT = TEXT_CONTENT;
var BUTTONS = {
  CHECK_CONTINUE: {
    title: 'Check and Continue',
    variant: 'primary',
    size: 'medium'
  },
  COPY_INTEGRATION: {
    title: 'Copy Integration Code',
    variant: 'success',
    size: 'medium',
    icon: 'copy'
  },
  RETRY_CONNECTION: {
    title: 'Retry Connection Check',
    variant: 'secondary',
    size: 'medium',
    icon: 'inProgress'
  }
};
exports.BUTTONS = BUTTONS;